import './styles.sass';
import {
  Note,
  Text,
  YesNo,
  Header,
  Bullets,
  Confirm,
  Dropdown,
  TextArea,
  Multiple,
  OptionsRow,
  OptionsColumn,
} from './types';

export const Question = ({ error, value, question, onChange, isReview }) => {
  if (!question.Visible) return null;

  let QuestionComponent = null;

  const {
    ID,
    Required,
    GridSize,
    QuestionType,
    QuestionView,
    QuestionNumber,
    QuestionOptions,
    QuestionDescription,
  } = question;

  const onResponse = (value) => {
    onChange({ id: ID, question: QuestionDescription, value });
  };

  switch (QuestionType) {
    case 'Header': {
      QuestionComponent = <Header value={QuestionDescription} />;
      break;
    }
    case 'Note': {
      QuestionComponent = <Note value={QuestionDescription} />;
      break;
    }
    case 'Bullets': {
      QuestionComponent = (
        <Bullets value={QuestionDescription} options={QuestionOptions} />
      );
      break;
    }
    case 'Text': {
      QuestionComponent = (
        <Text
          error={error}
          grid={GridSize}
          required={Required}
          onChange={onResponse}
          value={value}
          question={QuestionDescription}
          helperText={error && 'Required field'}
        />
      );
      break;
    }
    case 'TextArea': {
      QuestionComponent = (
        <TextArea
          error={error}
          grid={GridSize}
          required={Required}
          onChange={onResponse}
          value={value}
          question={QuestionDescription}
        />
      );
      break;
    }
    case 'Confirm': {
      QuestionComponent = (
        <Confirm
          error={error}
          grid={GridSize}
          onChange={onResponse}
          checked={Boolean(value)}
          question={QuestionDescription}
        />
      );
      break;
    }
    case 'Yes/No': {
      QuestionComponent = (
        <YesNo
          error={error}
          grid={GridSize}
          onChange={onResponse}
          value={value || false}
          question={QuestionDescription}
          questionNumber={QuestionNumber}
        />
      );
      break;
    }
    case 'Admin Dropdown': {
      if (!isReview) {
        QuestionComponent = <></>;
        break;
      }
      QuestionComponent = (
        <Dropdown
          grid={GridSize}
          onChange={onResponse}
          value={value || ''}
          options={QuestionOptions}
          question={QuestionDescription}
        />
      );
      break;
    }
    case 'Dropdown': {
      QuestionComponent = (
        <Dropdown
          grid={GridSize}
          onChange={onResponse}
          value={value || ''}
          options={QuestionOptions}
          question={QuestionDescription}
        />
      );
      break;
    }
    case 'Options': {
      if (QuestionView === 'row') {
        QuestionComponent = (
          <OptionsRow
            error={error}
            grid={GridSize}
            required={Required}
            onChange={onResponse}
            value={value}
            options={QuestionOptions}
            question={QuestionDescription}
            helperText={error && 'Required field'}
          />
        );
      } else if (QuestionView === 'column') {
        QuestionComponent = (
          <OptionsColumn
            error={error}
            value={value}
            grid={GridSize}
            onChange={onResponse}
            options={QuestionOptions}
            question={QuestionDescription}
            helperText={error && 'Required field'}
          />
        );
      } else {
        QuestionComponent = (
          <Multiple
            error={error}
            grid={GridSize}
            onChange={onResponse}
            value={value}
            options={QuestionOptions}
            question={QuestionDescription}
            helperText={error && 'Required field'}
          />
        );
      }
      break;
    }
  }

  return QuestionComponent;
};
